/* eslint-disable react-hooks/exhaustive-deps */
import { CheckCircleOutline, ErrorOutline, ExpandLess, ExpandMore, LockReset, Person, Save } from '@mui/icons-material';
import { Alert, Box, Button, Collapse, Divider, Grid, IconButton, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';

import { ContainerApp, LoadingApp, PaperApp } from '../components/custom/CustomComponents';
import { Context } from '../service/Context';

const Configuracion = () => {
  const { idUsuario, obtenerDatosUsuario, actualizarUsuario } = useContext(Context);

  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [mostrarCambioPassword, setMostrarCambioPassword] = useState(false);
  const [datos, setDatos] = useState({
    usuario: '',
    nombre: '',
    apellidos: '',
    contrasenaActual: '',
    contrasena: '',
    confirmarContrasena: '',
  });
  const [mensaje, setMensaje] = useState({ texto: '', tipo: '' });

  useEffect(() => {
    const cargarDatos = async () => {
      setLoading(true);
      if (idUsuario) {
        const usuario = await obtenerDatosUsuario(idUsuario);
        if (usuario) {
          setDatos({
            usuario: usuario.usuario || '',
            nombre: usuario.nombre || '',
            apellidos: usuario.apellidos || '',
            contrasenaActual: '',
            contrasena: '',
            confirmarContrasena: '',
          });
        }
      }
      setLoading(false);
    };
    cargarDatos();
  }, [idUsuario]);

  const handleChange = (prop) => (event) => {
    setDatos({ ...datos, [prop]: event.target.value });
  };

  const handleGuardar = async () => {
    setMensaje({ texto: '', tipo: '' });

    if (mostrarCambioPassword || datos.contrasena || datos.contrasenaActual || datos.confirmarContrasena) {
      if (!datos.contrasenaActual) {
        setMensaje({ texto: 'Debes introducir tu contraseña actual para cambiarla.', tipo: 'error' });
        return;
      }
      if (!datos.contrasena) {
        setMensaje({ texto: 'Debes introducir una nueva contraseña.', tipo: 'error' });
        return;
      }
      if (datos.contrasena !== datos.confirmarContrasena) {
        setMensaje({ texto: 'Las contraseñas no coinciden.', tipo: 'error' });
        return;
      }
    }

    const datosActualizar = {
      nombre: datos.nombre,
      apellidos: datos.apellidos,
      contrasena: datos.contrasena,
      contrasenaActual: datos.contrasenaActual,
    };

    setGuardando(true);
    const respuesta = await actualizarUsuario(idUsuario, datosActualizar);
    if (respuesta.exito) {
      setMensaje({ texto: respuesta.mensaje || 'Cambios guardados correctamente.', tipo: 'success' });
      setDatos((prev) => ({ ...prev, contrasena: '', confirmarContrasena: '', contrasenaActual: '' }));
      setMostrarCambioPassword(false);
    } else {
      setMensaje({ texto: respuesta.mensaje || 'Error al guardar los cambios.', tipo: 'error' });
    }

    setGuardando(false);
  };

  if (loading) {
    return <LoadingApp />;
  }

  return (
    <ContainerApp sx={{ maxWidth: 680, mx: 'auto', px: 2, py: 3 }}>
      <PaperApp
        sx={{
          p: { xs: 2.5, sm: 3.5 },
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
          border: '1px solid #e2e8f0',
          backgroundColor: '#ffffff',
        }}
      >
        {/* Cabecera del Panel */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3 }}>
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: '10px',
              backgroundColor: '#ecfdf5',
              border: '1px solid #a7f3d0',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: '#0f766e',
            }}
          >
            <Person sx={{ fontSize: '1.5rem' }} />
          </Box>
          <Box>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0f172a', fontSize: '1.15rem' }}>
              Configuración de la Cuenta
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '0.80rem' }}>
              Gestiona tu información personal y credenciales de acceso
            </Typography>
          </Box>
        </Box>

        {mensaje.texto && (
          <Alert
            severity={mensaje.tipo}
            icon={mensaje.tipo === 'success' ? <CheckCircleOutline /> : <ErrorOutline />}
            sx={{ mb: 3, borderRadius: 1.5, fontSize: '0.85rem' }}
          >
            {mensaje.texto}
          </Alert>
        )}

        {/* Sección: Datos del Usuario */}
        <Box sx={{ mb: 3.5 }}>
          <Typography
            variant="subtitle2"
            sx={{
              fontWeight: 700,
              color: '#334155',
              fontSize: '0.85rem',
              textTransform: 'uppercase',
              letterSpacing: '0.04em',
              mb: 2,
            }}
          >
            Información del Perfil
          </Typography>

          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                fullWidth
                size="small"
                label="Nombre de Usuario"
                value={datos.usuario}
                disabled
                helperText="El nombre de usuario no se puede modificar"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: '#f8fafc',
                    borderRadius: 1.5,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Nombre"
                value={datos.nombre}
                onChange={handleChange('nombre')}
                placeholder="Tu nombre"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                }}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                size="small"
                label="Apellidos"
                value={datos.apellidos}
                onChange={handleChange('apellidos')}
                placeholder="Tus apellidos"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>

        <Divider sx={{ my: 3, borderColor: '#f1f5f9' }} />

        {/* Sección: Seguridad / Cambio de Contraseña Plegable */}
        <Box sx={{ mb: 3 }}>
          <Box
            onClick={() => setMostrarCambioPassword(!mostrarCambioPassword)}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              p: 1.5,
              borderRadius: 1.5,
              border: '1px solid',
              borderColor: mostrarCambioPassword ? '#0f766e' : '#e2e8f0',
              backgroundColor: mostrarCambioPassword ? '#f0fdfa' : '#f8fafc',
              cursor: 'pointer',
              userSelect: 'none',
              transition: 'all 0.2s ease-in-out',
              '&:hover': {
                borderColor: '#0f766e',
                backgroundColor: '#f0fdfa',
              },
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
              <LockReset sx={{ color: '#0f766e', fontSize: '1.25rem' }} />
              <Box>
                <Typography sx={{ fontWeight: 600, fontSize: '0.85rem', color: '#0f172a' }}>
                  Cambiar Contraseña
                </Typography>
                <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
                  {mostrarCambioPassword
                    ? 'Completa los campos a continuación para actualizar tu contraseña'
                    : 'Haz clic aquí si deseas actualizar tu contraseña de acceso'}
                </Typography>
              </Box>
            </Box>
            <IconButton size="small" sx={{ color: '#0f766e' }}>
              {mostrarCambioPassword ? <ExpandLess /> : <ExpandMore />}
            </IconButton>
          </Box>

          <Collapse in={mostrarCambioPassword} timeout="auto" unmountOnExit>
            <Box
              sx={{
                mt: 2,
                p: 2.5,
                borderRadius: 1.5,
                backgroundColor: '#ffffff',
                border: '1px solid #e2e8f0',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              }}
            >
              <TextField
                fullWidth
                size="small"
                type="password"
                label="Contraseña Actual"
                autoComplete="current-password"
                value={datos.contrasenaActual}
                onChange={handleChange('contrasenaActual')}
                placeholder="Introduce tu contraseña actual"
                helperText="Requerida para confirmar cualquier cambio de clave"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                }}
              />

              <TextField
                fullWidth
                size="small"
                type="password"
                label="Nueva Contraseña"
                autoComplete="new-password"
                value={datos.contrasena}
                onChange={handleChange('contrasena')}
                placeholder="Mínimo 6 caracteres recomendados"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                }}
              />

              <TextField
                fullWidth
                size="small"
                type="password"
                label="Confirmar Nueva Contraseña"
                autoComplete="new-password"
                value={datos.confirmarContrasena}
                onChange={handleChange('confirmarContrasena')}
                placeholder="Repite la nueva contraseña"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 1.5,
                  },
                }}
              />
            </Box>
          </Collapse>
        </Box>

        {/* Botón de Guardado */}
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 1 }}>
          <Button
            variant="contained"
            onClick={handleGuardar}
            disabled={guardando}
            startIcon={<Save sx={{ fontSize: '1.1rem !important' }} />}
            sx={{
              backgroundColor: '#0f766e',
              color: '#ffffff',
              px: 3,
              py: 1,
              fontSize: '0.85rem',
              fontWeight: 600,
              borderRadius: 1.5,
              textTransform: 'none',
              boxShadow: '0 2px 6px rgba(15, 118, 110, 0.25)',
              '&:hover': {
                backgroundColor: '#0d9488',
                boxShadow: '0 4px 10px rgba(15, 118, 110, 0.35)',
              },
            }}
          >
            {guardando ? 'Guardando...' : 'Guardar Cambios'}
          </Button>
        </Box>
      </PaperApp>
    </ContainerApp>
  );
};

export default Configuracion;
